import { z } from 'zod';
import { idSchema, timestamps } from './utility';

export const bankAccountSchema = z.object({
  id: idSchema,
  model_id: idSchema,
  model_type: z.string(),
  account_holder_name: z.string(),
  account_number: z.string().nullable(),
  iban: z.string().nullable(),
  bic: z.string().nullable(),
  bank_name: z.string().nullable(),
  ...timestamps,
});
export type BankAccount = z.infer<typeof bankAccountSchema>;
